export const dashboardContext = {

    filters: {},

    lockStatut: true,
    showStatut: true,
    showStatutFilter: false,
    statusField: "managementStatut",

    medicamentStrategy: {

        showDestination: true,
        showDosage: false,
        showSiBesoin: true,
        showClassificationMedicament: true,
        workflowValidationField: "managementValidated",

        ROBOT: {
            showRobotFields: false,
            showEtiquetageFields: false
        },

        ETIQUETAGE: {
            showRobotFields: false,
            showEtiquetageFields: false
        }
    }
};
